// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__lU+m9","labels":"styles_labels__g1EeI","label":"styles_label__1bPVc","subLabel":"styles_subLabel__rrAAn"};